import React from 'react';

import './styles.css';

const Loader = () => (
  <div className="Loader">
    <svg className="circular-loader" viewBox="25 25 50 50">
      <circle
        className="loader-path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="#3b90ff"
        strokeWidth="3"
      />
    </svg>
  </div>
);

export default Loader;
